<mat-icon>warning</mat-icon>
<div class="numero_piezas">{{ numeroIncidencias }}</div>
<div class="descripcion">INCIDENCIAS PENDIENTES DE SOLUCIÓN</div>
